import { get } from "lodash";
import getDebtor from "./getDebtor";

const getDebtorMaster = state => get(getDebtor(state), "master");

export default getDebtorMaster;
